const globalStyleId = 'gs-text-main';
const defaultSelector = {
  selector: '#{mID} .gf_article-title',
};
export default {
  defaultClass: 'gf_gs-text-heading-3',
  settingGroups: {
    [globalStyleId]: {
      fontWeight: {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      'line-height': {
        ...defaultSelector,
        inherit: 'text.lineHeight',
        cssAttr: 'line-height',
        listUnit: 'em',
      },
      // "color": {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
      'font-style': {
        ...defaultSelector,
        inherit: 'text.fontStyle',
        cssAttr: 'font-style',
      },
    },
  },
};

export const ARTICLE_TITLE_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    isRenderColumn: true,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
  },
];
